import { useEffect } from "react";
import CatalogView from "@/components/feature/CatalogView";

const TITLE = "电视剧频道 - 白虎影视平台";
const DESCRIPTION =
  "浏览白虎精选电视剧资源，支持类型、地区、年份、剧集数筛选，查看热播剧集详情与介绍。";

export default function TvSeries() {
  useEffect(() => {
    document.title = TITLE;
    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute("content", DESCRIPTION);
    }
  }, []);

  return (
    <CatalogView
      category="tv"
      title="电视剧频道"
      breadcrumb="电视剧频道"
      description="浏览白虎精选电视剧资源，支持类型、地区、年份与剧集数筛选。每一部剧集都附有集数、主创与剧情简介，帮你快速挑选下一部要追的剧。"
    />
  );
}